import axios from 'axios'
export const getEmailPatterns = () => window.marketplace.state.app.email_patterns.patterns
export const getWhiteList = () => window.marketplace.state.app.email_patterns.white_list
export const getNamePatterns = () => window.marketplace.state.app.name_patterns.patterns
export const getEmailSpamDomains = () => window.marketplace.state.app.spam_domains

/**
 * @params email string
 * @returns @bool
 */
export const emailIsValid = email => {
  let patterns = getEmailPatterns()
  let whiteList = getWhiteList()

  let text
  let blocked = []
  patterns.forEach(pattern => {
    if (pattern.type === 'name') {
      text = email.substr(0, email.lastIndexOf('@')).toLowerCase()
      blocked.push(new RegExp(pattern.word).test(text))
    } else if (pattern.type === 'domain') {
      text = email.substr(email.lastIndexOf('@') + 1).toLowerCase()
      blocked.push(pattern.word === text)
    }
  })

  let isInWhiteList = whiteList.indexOf(email) !== -1

  return !blocked.includes(true) || isInWhiteList
}

export const emailIsSpammer = async email => {
  let spamDomains = getEmailSpamDomains()
  let checkSpammer = false

  spamDomains.forEach(domain => {
    if (email.search(domain) > -1) {
      checkSpammer = true
    }
  })

  if (checkSpammer) {
    let response = await axios.post('/verify-email-exists', {email})
    return response.data.emailExists
  }
  return false
}

/**
 * @returns @bool
 */
export const namesAreValid = (firstName, lastName) => {
  firstName = firstName ? firstName.toString().toLowerCase() : ''
  lastName = lastName ? lastName.toString().toLowerCase() : ''

  let patterns = getNamePatterns()
  let blocked = []

  patterns.forEach(pattern => {
    pattern = pattern.toLowerCase()
    blocked.push((firstName === pattern) || (lastName === pattern))

    if (pattern.includes(' ')) {
      var patternPieces = []
      patternPieces = pattern.split(' ')

      if (patternPieces.length === 3) { // AM-3111
        var patternPiecesA1 = patternPieces.shift()
        var patternPiecesB1 = patternPieces.join(' ')

        var patternPiecesB2 = patternPiecesB1.split(' ')
        var patternPiecesA2 = patternPiecesA1 + ' ' + patternPiecesB2[0]

        // Check if first name matches first word and last name matches last 2 words
        blocked.push((firstName === patternPiecesA1) && (lastName === patternPiecesB1))

        // Check if first name matches first 2 words and last name matches last word
        blocked.push((firstName === patternPiecesA2) && (lastName === patternPiecesB2[1]))
      } else {
        blocked.push((firstName === patternPieces[0]) && (lastName === patternPieces[1]))
      }
    } else { // For single word "phishing names" such as 'marketplace', ensure we check against the text of the full name
      var fullName = firstName + ' ' + lastName // "Market Place" will fail as a fullname
      var fullNameConjoined = firstName + lastName // "2Marketplace2 TestMe" will fail as a fullname

      if (fullName.indexOf(pattern) > -1) { // AM-3117
        blocked.push(true)
      } else if (fullNameConjoined.indexOf(pattern) > -1) {
        blocked.push(true)
      }
    }

    if (blocked.includes(true)) {
      return !blocked.includes(true)
    }
  })

  return !blocked.includes(true)
}
